import { render, staticRenderFns } from "./Jantri.vue?vue&type=template&id=472bb056&scoped=true&"
import script from "./Jantri.vue?vue&type=script&lang=js&"
export * from "./Jantri.vue?vue&type=script&lang=js&"
import style0 from "./Jantri.vue?vue&type=style&index=0&id=472bb056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472bb056",
  null
  
)

export default component.exports